/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const EventsIcon = ({ width = 24, height = 24, hidden = false, title = 'Events' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M32.615 28.135a.461.461 0 0 1-.461.465l-8.769.015-6.6 7.249a.452.452 0 0 1-.323.136.461.461 0 0 1-.462-.462V12.462a.461.461 0 0 1 .465-.462.452.452 0 0 1 .323.136l15.691 15.676a.451.451 0 0 1 .136.323Zm-21.629 1.592 2.872-5.008a.457.457 0 0 0-.188-.617l-1.181-.677a.456.456 0 0 0-.627.15l-2.871 5.008a.457.457 0 0 0 .188.617l1.18.677a.456.456 0 0 0 .627-.15ZM24.452 7.89l2.871-5.008a.456.456 0 0 0-.187-.617l-1.181-.677a.456.456 0 0 0-.627.15l-2.871 5.008a.456.456 0 0 0 .187.617l1.181.677a.456.456 0 0 0 .627-.15ZM3.973 23.323l5.267-2.365a.457.457 0 0 0 .211-.609l-.558-1.242a.456.456 0 0 0-.6-.247l-5.262 2.364a.457.457 0 0 0-.211.609l.558 1.242a.456.456 0 0 0 .595.248Zm23.734-10.209 5.267-2.364a.457.457 0 0 0 .211-.609L32.627 8.9a.456.456 0 0 0-.6-.247l-5.267 2.364a.457.457 0 0 0-.211.609l.558 1.242a.455.455 0 0 0 .6.246Zm-25.24.571 5.65 1.183a.456.456 0 0 0 .529-.369l.279-1.332a.457.457 0 0 0-.336-.55l-5.651-1.183a.456.456 0 0 0-.529.369l-.279 1.332a.457.457 0 0 0 .337.55Zm25.139 5.672 5.651 1.183a.457.457 0 0 0 .529-.369l.278-1.332a.455.455 0 0 0-.336-.55l-5.65-1.183a.456.456 0 0 0-.529.369l-.279 1.332a.457.457 0 0 0 .336.55ZM6.924 4.633 10.8 8.911a.457.457 0 0 0 .645.013l1.008-.914a.458.458 0 0 0 .052-.643L8.629 3.089a.457.457 0 0 0-.645-.013l-1.009.914a.457.457 0 0 0-.051.643ZM15.549.639l.621 5.74a.456.456 0 0 0 .514.388l1.353-.146a.455.455 0 0 0 .419-.49L17.835.392A.456.456 0 0 0 17.321 0l-1.353.149a.455.455 0 0 0-.419.49Z"
    />
  </svg>`;
};
